var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.636,
    height: 13.3,
    viewBox: "0 0 13.636 13.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M5204.262,31.35a6.819,6.819,0,0,0-2.154,13.288c.341.063.465-.148.465-.328,0-.162-.006-.591-.009-1.16-1.9.412-2.3-.914-2.3-.914a1.8,1.8,0,0,0-.757-1c-.619-.424.047-.415.047-.415a1.431,1.431,0,0,1,1.044.7,1.451,1.451,0,0,0,1.984.566,1.461,1.461,0,0,1,.433-.911c-1.514-.172-3.1-.757-3.1-3.37a2.64,2.64,0,0,1,.7-1.83,2.453,2.453,0,0,1,.067-1.8s.573-.183,1.875.7a6.45,6.45,0,0,1,3.414,0c1.3-.882,1.873-.7,1.873-.7a2.45,2.45,0,0,1,.068,1.8,2.633,2.633,0,0,1,.7,1.83c0,2.619-1.594,3.2-3.113,3.364a1.628,1.628,0,0,1,.463,1.263c0,.912-.009,1.647-.009,1.871,0,.182.123.394.469.327a6.819,6.819,0,0,0-2.16-13.287Z",
    transform: "translate(-5197.445 -31.35)",
    fill: "#98a9b8",
    fillRule: "evenodd",
    opacity: 0.65
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0d955604bc203e8dcb75fac684c55b17.svg";
export { ForwardRef as ReactComponent };